import { connect } from 'react-redux';
import ScrollWrapper from '../components/ScrollWrapper.jsx';

import { getCurrentUser } from '../selectors';

const mapStateToProps = (state, props) => {
  return Object.assign({}, state.decks.byId[props.id] || {}, {
    clientTypeId: getCurrentUser(state).client_type_id
  });
};

export default connect(
  mapStateToProps,
  null
)(ScrollWrapper);
